var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5041 16.4968H19.3609V11.4831C19.3609 7.74527 16.8386 4.6462 13.4961 3.91754C13.7011 3.61368 13.7893 3.27894 13.7893 2.8849V2.85404C13.7893 1.8214 12.9978 1 12.0001 1C11.0035 1 10.2108 1.82018 10.2108 2.85404V2.88371C10.2108 3.27897 10.3276 3.61249 10.5041 3.91635C7.16167 4.64513 4.63919 7.74561 4.63919 11.4819V16.4646L3.49601 16.4658C2.67469 16.4658 2 17.1649 2 18.016C2 18.867 2.67469 19.5958 3.49601 19.5958H10.1523V20.8421C10.1523 22.0267 10.9736 23 12 23C13.0264 23 13.8477 22.0279 13.8477 20.8421V19.5958H20.504C21.3253 19.5958 22 18.8967 22 18.0456C22 17.1957 21.3253 16.4966 20.504 16.4966L20.5041 16.4968Z",
    fill: "#505B73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.7b203e25a6904a62efae3e16f0053a15.svg";
export { ForwardRef as ReactComponent };